<template>
  <div class="facial-analysis-page">
    <van-nav-bar
      title="面诊报告"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      safe-area-inset-top
    />

    <div class="teal-bg">
       <div class="white-container">
        
        <!-- 头部：头像与标题 -->
        <div class="header-wrap">
          <img class="avatar" :src="headImg" v-if="headImg" />
          <span class="header-title">面诊解析</span>
        </div>

        <!-- 面诊解析表格 (与 face-diagnosis 保持一致) -->
        <div class="custom-table" v-if="list && list.length">
          <div class="table-header">
            <div class="col-1">面像分析</div>
            <div class="col-2">检测结果</div>
            <div class="col-3">标准值</div>
          </div>
          <div class="table-row" v-for="(item, index) in list" :key="index">
            <div class="col-1">{{ item.name }}</div>
            <div class="col-2" :class="{'warn-text': isWarn(item.result)}">{{ item.result }}</div>
            <div class="col-3">{{ item.standard }}</div>
          </div>
        </div>

        <!-- 各个分区具体内容卡片 -->
        <div class="cards-list" v-if="list && list.length">
          <div class="analysis-card" v-for="(item, index) in list" :key="`card-${index}`">
            <div class="card-header">
              <div class="card-title">{{ item.name }}</div>
              <div class="card-standard">{{ item.standard }}</div>
            </div>
            <div class="card-body">
              <div class="info-row">
                <span class="label">检测结果：</span>
                <span class="value">{{ item.result }}{{ item.resultDesc ? '，' + item.resultDesc : '' }}</span>
              </div>
              <div class="info-row" style="margin-top: 12px;">
                <span class="label">病理意义：</span>
                <span class="value">{{ item.significance || '暂无' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部声明与时间 -->
        <div class="bottom-statement" style="margin-top: 24px;">
          <div class="statement-text">
            重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论，如已有身体不适，请及时咨询医生。
          </div>
          <div class="time-text" v-if="createAt">
            生成时间：{{ formatTime(createAt) }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant';

export default {
  name: 'MyAiFacialAnalysis',
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
  },
  data() {
    return {
      headImg: '',
      createAt: '',
      list: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    loadData() {
      const dataStr = sessionStorage.getItem("MY_AI_FACIAL_ANALYSIS");
      if (dataStr) {
        try {
          const data = JSON.parse(dataStr);
          this.headImg = data.headImg || '';
          this.createAt = data.createAt || '';
          if (data.facialAnalysis && data.facialAnalysis.list) {
            this.list = data.facialAnalysis.list;
          }
        } catch (e) {
          console.error("解析面诊解析数据失败", e);
        }
      }
    },
    isWarn(result) {
      if (!result) return false;
      return result !== '无' && result !== '正常';
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      try {
        const parts = timeStr.split(' ');
        const dateParts = parts[0].split('-');
        return `${dateParts[0]}年${parseInt(dateParts[1], 10)}月${parseInt(dateParts[2], 10)}日 ${parts[1] || ''}`;
      } catch (e) {
        return timeStr;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.facial-analysis-page {
  background: #44C2C4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.teal-bg {
  flex: 1;
  background: #44C2C4;
  padding: 16px 12px;
}

.white-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

/* 头部 */
.header-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 表格 (复用 face-diagnosis 的样式) */
.custom-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.table-header {
  display: flex;
  background: #44C2C4;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.table-row {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
}

.table-row:nth-child(even) {
  background: #fcfcfc;
}

.col-1 { flex: 1.2; padding: 12px 8px; text-align: center; }
.col-2 { flex: 1; padding: 12px 8px; text-align: center; }
.col-3 { flex: 1.5; padding: 12px 8px; text-align: center; line-height: 1.4; }

.warn-text {
  color: #FF5A5A;
}

/* 卡片列表 */
.cards-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.analysis-card {
  background: #F7F8FA;
  border-radius: 8px;
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px dashed #e5e5e5;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.card-standard {
  font-size: 14px;
  color: #8B5E3C;
  max-width: 60%;
  text-align: right;
  line-height: 1.4;
  font-weight: 500;
}

.card-body {
  padding: 12px 16px;
  font-size: 13px;
  color: #333;
  line-height: 1.6;
}

.info-row {
  display: flex;
  align-items: flex-start;
}

.label {
  font-weight: bold;
  flex-shrink: 0;
  color: #333;
}

.value {
  color: #666;
}

/* 底部声明 */
.bottom-statement {
  padding: 16px 12px;
  border-radius: 8px;
  background: transparent;
}

.statement-text {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  text-align: justify;
}

.time-text {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  text-align: center;
}
</style>